import { buildAction } from 'store/actions/actionCreator'

import { FETCH_SYSTEM, SET_ERROR, SET_IS_PROD, SET_RANGES } from './constants'

export const fetchSystem = buildAction(FETCH_SYSTEM)

export const setError = buildAction(SET_ERROR, 'payload')

export const setIsProd = buildAction(SET_IS_PROD, 'payload')

export const setRanges = buildAction(SET_RANGES, 'payload')
